import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {m} from "@pg-design/helpers-css";
import {CarOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {countDistance} from "@pg-mono/geo-utils";
import {convertToLatLngLiteralOfPoland} from "@pg-mono/open-street-map";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IRPStore} from "../../../../app/rp_reducer";
import {addUserPoi} from "../../../../maps/actions/manage_user_poi";
import {PoiType} from "../../../../maps/utils/PoiType";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {TravelMode} from "../../../../property/utils/TravelMode";
import {useComparisonToolContext} from "../../../contexts/comparison_tool_context";
import {useCalculateTravelTime} from "../../../hooks/use_calculate_travel_time";

export const ChangePlaceCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const theme = useTheme();
    const {myPlace} = useComparisonToolContext();
    const property = props.item;

    const dispatch = useDispatch();
    const userPois = useSelector((state: IRPStore) => state.maps.userPoi);
    const calculateTravelTime = useCalculateTravelTime();
    const [travelTime, setTravelTime] = useState<string | null>(null);

    const propertyDetails = property;

    useEffect(() => {
        if (!myPlace) {
            return;
        }

        const poiLocation = convertToLatLngLiteralOfPoland(myPlace.location.coordinates);
        const targetLocation = convertToLatLngLiteralOfPoland(propertyDetails.offer.geo_point.coordinates);

        const userPoi = {
            id: Date.now(),
            distance: countDistance(poiLocation, targetLocation),
            lat: poiLocation.lat,
            lng: poiLocation.lng,
            name: myPlace.name,
            tags: {address: myPlace.location.label ? myPlace.location.label : ""}
        };

        const currentPoi = userPois.find((storedUserPoi) => userPoi.lat === storedUserPoi.lat && userPoi.lng === storedUserPoi.lng);

        if (currentPoi) {
            calculateTravelTime(currentPoi, PoiType.USER, propertyDetails.offer.geo_point.coordinates, TravelMode.DRIVING).then((duration) => {
                setTravelTime(duration);
            });
        }

        if (!currentPoi && myPlace) {
            dispatch(addUserPoi(userPoi));
        }
    }, [userPois.length, myPlace]);

    if (!myPlace || !travelTime) {
        return <div>-</div>;
    }

    return (
        <div css={myPlaceWrapStyle}>
            <Text variant="info_txt_1">
                <span css={myPlaceNameStyle}>{myPlace.name}</span>, {myPlace.location.label}
            </Text>
            <div css={timeInfoWrapStyle}>
                <div css={carIconWrap}>
                    <CarOutlineIcon size="1.6" fill={theme.colors.secondary} />
                </div>
                <Text variant="info_txt_1" css={timeWrapStyle}>
                    {travelTime}
                </Text>
            </div>
        </div>
    );
};

const myPlaceWrapStyle = css`
    display: flex;
    flex-direction: column;
`;

const myPlaceNameStyle = css`
    font-weight: 700;
`;

const timeWrapStyle = css`
    font-weight: 700;
`;

const timeInfoWrapStyle = css`
    display: flex;
`;

const carIconWrap = css`
    width: 1.6rem;
    height: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    ${m(0, 0.5, 0, 0)}
`;
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {m} from "@pg-design/helpers-css";
import {CarOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {countDistance} from "@pg-mono/geo-utils";
import {convertToLatLngLiteralOfPoland} from "@pg-mono/open-street-map";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IRPStore} from "../../../../app/rp_reducer";
import {addUserPoi} from "../../../../maps/actions/manage_user_poi";
import {PoiType} from "../../../../maps/utils/PoiType";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {TravelMode} from "../../../../property/utils/TravelMode";
import {useComparisonToolContext} from "../../../contexts/comparison_tool_context";
import {useCalculateTravelTime} from "../../../hooks/use_calculate_travel_time";

export const ChangePlaceCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const theme = useTheme();
    const {myPlace} = useComparisonToolContext();
    const property = props.item;

    const dispatch = useDispatch();
    const userPois = useSelector((state: IRPStore) => state.maps.userPoi);
    const calculateTravelTime = useCalculateTravelTime();
    const [travelTime, setTravelTime] = useState<string | null>(null);

    const propertyDetails = property;

    useEffect(() => {
        if (!myPlace) {
            return;
        }

        const poiLocation = convertToLatLngLiteralOfPoland(myPlace.location.coordinates);
        const targetLocation = convertToLatLngLiteralOfPoland(propertyDetails.offer.geo_point.coordinates);

        const userPoi = {
            id: Date.now(),
            distance: countDistance(poiLocation, targetLocation),
            lat: poiLocation.lat,
            lng: poiLocation.lng,
            name: myPlace.name,
            tags: {address: myPlace.location.label ? myPlace.location.label : ""}
        };

        const currentPoi = userPois.find((storedUserPoi) => userPoi.lat === storedUserPoi.lat && userPoi.lng === storedUserPoi.lng);

        if (currentPoi) {
            calculateTravelTime(currentPoi, PoiType.USER, propertyDetails.offer.geo_point.coordinates, TravelMode.DRIVING).then((duration) => {
                setTravelTime(duration);
            });
        }

        if (!currentPoi && myPlace) {
            dispatch(addUserPoi(userPoi));
        }
    }, [userPois.length, myPlace]);

    if (!myPlace || !travelTime) {
        return <div>-</div>;
    }

    return (
        <div css={myPlaceWrapStyle}>
            <Text variant="info_txt_1">
                <span css={myPlaceNameStyle}>{myPlace.name}</span>, {myPlace.location.label}
            </Text>
            <div css={timeInfoWrapStyle}>
                <div css={carIconWrap}>
                    <CarOutlineIcon size="1.6" fill={theme.colors.secondary} />
                </div>
                <Text variant="info_txt_1" css={timeWrapStyle}>
                    {travelTime}
                </Text>
            </div>
        </div>
    );
};

const myPlaceWrapStyle = css`
    display: flex;
    flex-direction: column;
`;

const myPlaceNameStyle = css`
    font-weight: 700;
`;

const timeWrapStyle = css`
    font-weight: 700;
`;

const timeInfoWrapStyle = css`
    display: flex;
`;

const carIconWrap = css`
    width: 1.6rem;
    height: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    ${m(0, 0.5, 0, 0)}
`;
